import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import * as _ from 'lodash';

import { BaseModalComponent } from '../_base-modal.component';
import { FitmentsService } from '../../fitments/fitments.service';
import { BrandService } from '../../brand/brand.service';


@Component({
  moduleId: module.id,
  selector: 'fitment-duplicate-modal',
  templateUrl: 'fitment-duplicate-modal.component.html',
  styleUrls: ['fitment-duplicate-modal.component.scss'],
})
export class FitmentDuplicateModalComponent extends BaseModalComponent {

  @Input() mfrLabel: string;
  @Input() partTerminology: string;
  @Input() qty: number;
  @Input() positionId: any;
  @Input() notes: Array<any> = [];
  @Input() productId: any;

  @Output() confirm: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();

  positionName: string;

  constructor(
    private fitmentsService: FitmentsService,
    private brandService: BrandService,
  ) {
    super();
  }

  show() {
    this.fitmentsService.getPositions(
      this.brandService.getBrand(),
      this.productId,
    ).subscribe((data: any) => {
      this.positionName = _.get(_.find(data, ['option', +this.positionId]), 'title');
    });
    super.show();
  }

  onCopyBtnClick() {
    this.confirm.emit();
    this.hide();
  }

  onDontCopyBtnClick() {
    this.cancel.emit();
    this.hide();
  }
}
